import React, { forwardRef } from "react";
import { Button, useTab, useMultiStyleConfig, Box } from "@chakra-ui/react";
import { Pill } from "./pill";
const numberFormatter = new Intl.NumberFormat();
export const Tab = forwardRef(({ children, count }, ref) => {
    const tabProps = useTab({ ref });
    const styles = useMultiStyleConfig("Tabs", tabProps);
    const isSelected = Boolean(tabProps["aria-selected"]);
    return (React.createElement(Button, { __css: styles["tab"], ...tabProps },
        children,
        typeof count === "number" && (React.createElement(Box, { as: "span", ml: 2 },
            React.createElement(Pill, null, numberFormatter.format(count)))),
        isSelected && (React.createElement(Box, { position: "absolute", bottom: -0.5, left: 0, right: 0, h: 0.5, bg: "forest", zIndex: 2 }))));
});
